<div class="grid-container margin-top">

  <div class="grid-x grid-margin-x">
    <div class="cell medium-12">
      <h2>Ad-Hoc Work Order</h2>
    </div>
  </div>

  <form [formGroup]="workOrderForm">

    <div class="grid-x grid-margin-x">
      <div class="cell medium-12">

        <label for="title">Task or Note Subject: *</label>

        <input type="text" id="title" formControlName="title" [(ngModel)]="workOrder.title" />

        @if (workOrderForm.controls['title'].invalid && (workOrderForm.controls['title'].dirty || workOrderForm.controls['title'].touched)) {
          <div class="error-container">
            @if (workOrderForm.get('title').hasError('required')) {
              <small class="error">Subject is required</small>
            }
          </div>
        }
      </div>
    </div>

    <div class="grid-x grid-margin-x">
      <div class="cell medium-12" style="text-align: center">
        <div class="radio-container">
          <p>Assign to:</p>
          <div class="radio">
            <input type="radio" value="group" formControlName="assigneeType" (change)="radioChanged($event)"> Group
          </div>
          <div class="radio">
            <input type="radio" value="user" formControlName="assigneeType" (change)="radioChanged($event)"> Contact
          </div>

          <!-- Not yet implemented -->
          <!--<div class="radio">
          <input type="radio" value="organization" formControlName="assigneeType" (change)="radioChanged($event)"> Organization</div>-->
          <!-- <div class="margin-top" *ngIf="currentAssignee.type === null && saveClicked">
          <small class="error">Please choose type of Assignee</small>
        </div> -->

        @if (workOrderForm.controls['assigneeType'].invalid && (workOrderForm.controls['assigneeType'].dirty || workOrderForm.controls['assigneeType'].touched)) {
          <div class="error-container margin-top">
            @if (workOrderForm.get('assigneeType').hasError('required')) {
              <small class="error">Assignee Type is required</small>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <div class="grid-x grid-margin-x">

    <div class="cell medium-6">

      <label for="assignee">Assignee: (type to search, is case-sensitive)</label>

      <input type="text" id="assignee" formControlName="assignee" (click)="searchEnter()"
        clickOutside (clickOutside)="searchLeave()" autocomplete="off" />

        @if (workOrderForm.controls['assignee'].invalid && (workOrderForm.controls['assignee'].dirty || workOrderForm.controls['assignee'].touched)) {
          <div class="error-container">
            @if (workOrderForm.get('assignee').hasError('required')) {
              <small class="error">Assignee is required</small>
            }
          </div>
        }

        @if (showDropDown) {
          <div class="search-results">
            @for (r of searchResults; track r) {
              <div class="result" (click)="assigneeSelected(r)">
                <span>{{r.displayName}}</span>
              </div>
            }
          </div>
        }

        @if (noAssigneeSearchResults) {
          <div class="search-results">
            <div class="result empty">
              <span>No results for "{{ workOrderForm.controls['assignee'].value }}"</span>
            </div>
          </div>
        }

      </div>

      <div class="cell medium-6">

        <label for="dueDate">Due Date:</label>
	  <common-date-picker [id]="'dueDate'" [pastDateLimit]="currentDate" (dateChanged)="dateChange($event)" [placeholder]="placeholder" [formGroup]="workOrderForm.get('dueDate')"></common-date-picker>

      @if (workOrderForm.controls['dueDate'].invalid && (workOrderForm.controls['dueDate'].dirty || workOrderForm.controls['dueDate'].touched)) {
        <div class="error-container date-Picker">
          @if (workOrderForm.get('dueDate').hasError('required')) {
            <small class="error">Due Date is required</small>
          }
        </div>
      }
    </div>

  </div>

  <div class="grid-x grid-margin-x">
    <div class="cell medium-12">

      <label for="link">The Company Number this Work Order involves: (Please type in the relevant company number)</label>

      <input type="text" id="organizationId" formControlName="organizationId"  [(ngModel)]="workOrder.organizationId"/>

    </div>
  </div>

  <div class="grid-x grid-margin-x">
    <div class="cell medium-12">

      <label for="link">Link to Work Item: (paste in work item to link)</label>

      <input type="text" id="link" formControlName="link" value="{{ workOrder.targetUrl }}" />

    </div>
  </div>

  <div class="grid-x grid-margin-x margin-bottom">
    <div class="cell medium-12">
      <label for="description">Details:</label>
      @if (viewOnly) {
        <div [innerHTML]="workOrder.description | safeHtml"></div>
      } @else {
        <div id="description" name="description" formControlName="description" [froalaEditor]="froalaOptions"></div>
        @if (workOrderForm.controls['description'].invalid && (workOrderForm.controls['description'].dirty || workOrderForm.controls['description'].touched)) {
          <div class="error-container margin-top">
            @if (workOrderForm.get('description').hasError('required')) {
              <small class="error">Description is required</small>
            }
          </div>
        }
      }
    </div>
  </div>

</form>

</div>